import { Component, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Router, RouterLink, ActivatedRoute } from '@angular/router';
import { NgClass } from '@angular/common';
import { UserProfileService } from '../../../core/api/services/user-profile/user-profile.service';
import { UrlConstants } from '../../../core/constants/url.constants';
import { ForgotCredentialsResponse } from '../../../core/models/user-profile/forgot-credentials-response';

import { SessionStorageConstants } from '../../../core/constants/session-storage.constant';
import { emailValidator } from '../../../core/util/custom-form-validators-util';
import {StandardFormFieldComponent} from '../../common/standard-form-field/standard-form-field.component';

@Component({
  selector: 'app-forgot-username',
  imports: [
    TranslatePipe,
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    RouterLink,
    StandardFormFieldComponent,
  ],
  templateUrl: './forgot-username.component.html',
  styleUrl: './forgot-username.component.css'
})
export class ForgotUsernameComponent implements OnInit {

  readonly userProfileService = inject(UserProfileService);
  readonly translateService = inject(TranslateService);
  readonly router = inject(Router);
  readonly activatedRoute = inject(ActivatedRoute);
  readonly UrlConstants = UrlConstants;

  errors: string[] = [];
  submitted = false;
  emailSent = false;
  loading = false;
  emailAddress: string = '';

  forgotUsernameForm: FormGroup = new FormGroup({
    emailAddress: new FormControl('', [Validators.required, emailValidator()])
  });

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params['email']) {
        this.emailSent = true;
        this.emailAddress = params['email'];
      }
    });
  }

  submit() {
    this.errors = [];
    this.submitted = true;
    this.forgotUsernameForm.get('emailAddress')?.markAsDirty();

    this.loading = true;

    if (this.forgotUsernameForm.valid) {
      const email = this.forgotUsernameForm.value.emailAddress;
      this.userProfileService.forgotUsername(email).subscribe({
        next: (response) => {
          this.loading = false;
          const outcome = response.outcome || '';
          if (outcome && outcome.includes('forgotUsernameConfirmation')) {
            this.emailSent = true;
            this.emailAddress = email;
            this.errors = [];
          } else {
            const errMsgKey = response?.errMsg || 'validation.emailNotFound';
            this.errors.push(this.translateService.instant('userprofile.' + errMsgKey, {
              0: SessionStorageConstants.CRC_DEV_SUPPORT_MAIL,
              1: SessionStorageConstants.CRC_DEV_SUPPORT_MAIL,
            }));
          }
        },
        error: (error) => {
          this.loading = false;
          const errorResponse: ForgotCredentialsResponse = error.error || {};
          const errMsgKey = errorResponse.errMsg || 'validation.emailNotFound';
          this.errors.push(this.translateService.instant('userprofile.' + errMsgKey));
        }
      });
    } else {
      this.loading = false;
      if (!this.forgotUsernameForm.value.emailAddress) {
        const email = this.translateService.instant('userprofile.label.email');
        this.errors.push(this.translateService.instant('userprofile.validation.confirmPassword.isRequired', {0: email}));
      } else if (this.forgotUsernameForm.get('emailAddress')?.hasError('email')) {
        this.errors.push(this.translateService.instant('userprofile.validation.invalidEmail'));      }
    }
  }
}
